<template>
  <div class="wt2-auto-complete -autocomplete" v-click-outside="clickOutside">
    <div class="wt-input-holder wt2-text-l" :class="inputClasses">
      <input
        ref="input"
        type="text"
        :value="tempValue"
        :placeholder="placeholder"
        :class="inputClasses"
        @input="onInput($event.target.value)"
        @mousedown="touched = true"
        @keydown="touched = true"
        :disabled="disableInput || true"
        @focus="setFocus"
      />
    </div>

    <div class="-twitter-operators" v-show="showTwitterOperators">
      <div class="-title">
        Try these searches for Twitter
        <div class="-close" @click="showTwitterOperators = false">
          <span class="wticon wticon-close"></span>
        </div>
      </div>
      <div class="-content">
        <table>
          <tr>
            <th>Operator</th>
            <th>Find tweets...</th>
          </tr>
          <tbody v-html="twitterOperators"></tbody>
        </table>
      </div>
    </div>

    <div class="-results" v-show="showResultsPanel">
      <div v-if="hasHistory" class="-clear" @click="clearHistory">
        <small class="wt2-link">Clear Recent</small>
      </div>
      <ul ref="results" :class="{ '-has-history': hasHistory }">
        <wt-highlighted-ac-result
          v-for="(i, key) in allSuggestions"
          @mouseenter.native="onHoverOnOption(key)"
          :class="{
            '-history': i.source === 'history',
            '-active': key === activeRowIndex,
          }"
          :key="i.id || i.text"
          :whole-text="i.text"
          :highlight="highlight"
          @mousedown.native="search({ text: i.text }, $event)"
        ></wt-highlighted-ac-result>
      </ul>
    </div>

    <transition name="wt2-fade-fast">
      <div class="-twitter-operators-button">
        <span @click="showTwitterOperators = !showTwitterOperators"
          >Options</span
        >
      </div>
    </transition>
    <transition name="wt2-fade-fast">
      <div v-show="tempValue.length" class="-clear" @click="clearTextBox">
        <div>
          <span class="wticon wticon-close_x"></span>
        </div>
      </div>
    </transition>
    <transition name="wt2-fade-fast">
      <div
        class="-search wt2-hover"
        :class="{ '-disabled': !canSearch }"
        @click="canSearch && search({ text: tempValue }, $event)"
      >
        <i class="wticon wticon-magnifier"></i>
      </div>
    </transition>
    <div class="-search-spacer"></div>
  </div>
</template>

<script>
import app from 'app';
import AutoCompleteMixins from './autoCompleteMixin.vue';

export default {
  mixins: [AutoCompleteMixins],
  data: function () {
    // eslint-disable max-len
    return {
      suggestionsFromServer: [],
      localHistoryFiltered: this.localHistory.slice(0, 5),
      showTwitterOperators: false,
      twitterOperators: `
          <tr><td>[Twitter Title] -RT</td><td>Find a specific tweet without retweets</td></tr>
          <tr><td>filter:verified</td><td>Find only results from verified accounts</td></tr>
          <tr><td>twitter search</td><td>containing both "twitter" and "search". This is the default operator.</td></tr>
          <tr><td><b>"</b>happy hour<b>"</b></td><td>containing the exact phrase "happy hour".</td></tr>
          <tr><td>love <b>OR</b> hate</td><td>containing either "love" or "hate" (or both).</td></tr>
          <tr><td>beer <b>-</b>root</td><td>containing "beer" but not "root".</td></tr>
          <tr><td><b>#</b>haiku</td><td>containing the hashtag "haiku".</td></tr>
          <tr><td><b>from:</b>alexiskold</td><td>sent from person "alexiskold".</td></tr>
          <tr><td><b>to:</b>techcrunch</td><td>sent to person "techcrunch".</td></tr>
          <tr><td><b>@</b>mashable</td><td>referencing person "mashable".</td></tr>
          <tr><td>superhero <b>since:</b>2010-12-27</td><td>containing "superhero" and sent since date "2010-12-27" (year-month-day).</td></tr>
          <tr><td>ftw <b>until:</b>2010-12-27</td><td>containing "ftw" and sent up to date "2010-12-27".</td></tr>
          <tr><td>movie -scary <b>:)</b></td><td>containing "movie", but not "scary", and with a positive attitude.</td></tr>
          <tr><td>flight <b>:(</b></td><td>containing "flight" and with a negative attitude.</td></tr>
          <tr><td>traffic <b>?</b></td><td>containing "traffic" and asking a question.</td></tr>
          <tr><td>hilarious <b>filter:links</b></td><td>containing "hilarious" and linking to URLs.</td></tr>
          <tr><td>news <b>source:twitterfeed</b></td><td>containing "news" and entered via TwitterFeed</td></tr>
        `,
    };
    // eslint-enabled max-len
  },
  props: {
    numHistoryItems: {
      type: Number,
      default: 3,
    },
    numSuggestions: {
      type: Number,
      default: 5,
    },
    acPromise: {
      type: Function,
      required: false,
      default: _.noop,
    },
    localHistory: {
      type: Array,
      default: () => [],
    },
    queryRequired: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    localHistory: {
      immediate: true,
      handler() {
        this.localHistoryFiltered = this.localHistory.slice(0, 5);
      },
    },
    value(newVal) {
      this.tempValue = newVal;
    },

    suggestionsFromServer(newVal) {
      this.$emit('response', newVal);
    },
  },
  computed: {
    query() {
      const value = this.value || '';
      return value.replace(/["']/g, '').trim();
    },
    inputClasses() {
      return {
        'wt-input': true,
        [this.inputClass]: true,
        '-with-button': !!this.button,
      };
    },
    showResultsPanel() {
      return (
        this.focused &&
        !this.disabled &&
        this.allSuggestions.length &&
        !this.showTwitterOperators
      );
    },
    allSuggestions() {
      let suggestions = this.suggestionsFromServer;

      suggestions = _.filter(suggestions, (s) => {
        const index = _.findIndex(this.localHistoryFiltered, { text: s.text });
        return index < 0;
      });

      return [...this.localHistoryFiltered, ...suggestions];
    },
    hasHistory() {
      return this.localHistoryFiltered.length > 0;
    },
    canSearch() {
      return !_.isEmpty(this.tempValue);
    },
  },
  beforeDestroy() {
    app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.TLLB);
  },
  methods: {
    onInput(newVal) {
      this.tempValue = newVal;
      this.highlight = newVal;
      this.showTwitterOperators = false;
      if (!this.disabled) {
        this.getSuggestionsFromServer(newVal);
        if (newVal) {
          this.localHistoryFiltered = this.filterSuggestions(
            this.localHistory,
            this.numHistoryItems,
            newVal
          );
        } else {
          this.localHistoryFiltered = this.localHistory.slice(0, 5);
        }
      }
    },
    onEnterPressed(e) {
      this.search({ text: this.tempValue }, e);
    },
    clickOutside() {
      this.showTwitterOperators = false;
      this.setBlur();
    },
    clearHistory() {
      this.localHistoryFiltered = [];
      this.$emit('clearHistory');
    },
    getSuggestionsFromServer(value) {
      value = (value || '').replace(/["']/g, '').trim();
      if (value) {
        const getPromise = this.acPromise(value);
        const p = getPromise.then((response) => {
          this.suggestionsFromServer = response.slice(0, +this.numSuggestions);
        });
        p.catch(() => (this.suggestionsFromServer = []));
      } else {
        this.suggestionsFromServer = [];
      }
    },
    search({ text }, e) {
      if (text) {
        this.tempValue = text;
        this.$emit('input', text);
        this.$emit('search', { e, activeRowIndex: this.activeRowIndex });
        if (!this.disabled) {
          this.$nextTick(() => {
            this.getSuggestionsFromServer(text);
            this.localHistoryFiltered = this.filterSuggestions(
              this.localHistory,
              this.numHistoryItems,
              text
            );
          });
        }
      } else {
        this.$emit('input', '');
        this.$emit('search', { e });
        this.suggestionsFromServer = [];
        this.localHistoryFiltered = this.localHistory.slice(0, 5);
      }
      this.focused = false;
      this.activeRowIndex = null;
      this.showTwitterOperators = false;
    },
    arrowPressed(offset) {
      if (this.disabled || !this.allSuggestions.length) {
        return;
      }
      if (this.activeRowIndex === null) {
        this.activeRowIndex = offset > 0 ? 0 : this.allSuggestions.length - 1;
      } else {
        this.activeRowIndex += offset;
      }
      if (this.activeRowIndex === this.allSuggestions.length) {
        this.activeRowIndex = 0;
      }
      if (this.activeRowIndex < 0) {
        this.activeRowIndex = this.allSuggestions.length - 1;
      }
      this.tempValue = this.allSuggestions[this.activeRowIndex].text;
      const el = this.$refs.results.childNodes[this.activeRowIndex];
      el.scrollIntoView({ block: 'center' });
    },
  },
};
</script>
